import {
  AdditionalConfiguration,
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionConfigurationControl,
  ReportSectionConfigurationControlType,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { PeerOwnerShipModel } from './peer-ownership.model';

export class ItineraryPeerOwnershipConfiguration extends ReportSectionConfigurationBase {
  typeName = 'ItineraryPeerOwnershipConfiguration';
  nodataLocalizationKeyName = 'peerOwnership';
  readonly reportSection = ReportSection.ItineraryPeerOwnership;
  readonly applicableReportTypes = [ReportType.Itinerary];
  readonly reportViewModelSections = [ReportViewModelSection.Itinerary_PeerOwnership];
  override totalColumnsToDisplay = 3;

  minSize = 1;
  maxSize = 3;
  defaultSize = 1;
  name = 'peerOwnership';
  displayName = 'Peer Ownership';
  type = ReportSectionConfigurationControlType.Table;
  isSelected = true;
  canConfigure = true;
  property = 'peerOwnership';
  readonly availableDataSections = [
    {
      name: 'peerOwnershipGridPeerName',
      displayName: 'Top Peers',
      isSelected: true,
      canConfigure: false,
      unit: 5,
      property: 'securityIssuerName',
      isStatic: true,
      type: ReportSectionConfigurationControlType.Text
    },
    {
      name: 'peerOwnershipGridValue',
      displayName: 'Value USD, mm',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'value',
      type: ReportSectionConfigurationControlType.Decimal
    },
    {
      name: 'peerOwnershipGridPctSO',
      displayName: 'Portfolio',
      isSelected: true,
      canConfigure: true,
      unit: 1,
      property: 'portfolioPct',
      type: ReportSectionConfigurationControlType.Text
    },
    {
      name: 'peerOwnershipGridValueChange',
      displayName: 'Share Change Value USD, mm',
      isSelected: true,
      canConfigure: true,
      unit: 2,
      property: 'sharesChangeValue',
      type: ReportSectionConfigurationControlType.Decimal
    }
  ];
  override additionalConfiguration: AdditionalConfiguration = {
    listCountConfig: {
      min: 1,
      max: 10,
      default: 5,
      value: 5,
      listCountHeader: 'noOfPeers'
    }
  };
  override configurationControls: ReportSectionConfigurationControl[] = [
    {
      name: 'peerOwnershipCount',
      displayName: 'Number of peers',
      type: 'listCount',
      defaultOption: 5
    }
  ];
}

export interface PeerOwnershipDetailsData {
  [ReportViewModelSection.Itinerary_PeerOwnership]: PeerOwnerShipModel;
}
